import { render, staticRenderFns } from "./BaseBottomSheet.vue?vue&type=template&id=755c8a92"
import script from "./BaseBottomSheet.vue?vue&type=script&lang=ts"
export * from "./BaseBottomSheet.vue?vue&type=script&lang=ts"
import style0 from "./BaseBottomSheet.vue?vue&type=style&index=0&id=755c8a92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
